import algoliasearch from 'algoliasearch/lite';
import slugify from 'slugify';

const client = algoliasearch('MHLN5RFG2E', '0945c05c23ad2cc711d88655aef9c8da');
const index = client.initIndex('journal');
const slugConf = {
    remove: /[./]/g,
    lower: true,
};

const showMetadata = function({ hits = [], nbHits = 0, nbPages = 0, page = 0, hitsPerPage = 20 }) {
    const meta = document.getElementById('search-meta');
    if (nbHits === 0) {
        meta.innerHTML = 'No results found.';
        return;
    }
    const low = page * hitsPerPage + 1;
    let high = low + (hitsPerPage - 1);
    if (high > nbHits) {
        high = nbHits;
    }
    meta.innerHTML = `Showing ${low} - ${high} results out of ${nbHits}. ${showPagination({ page, nbPages})}`;
};

const showPagination = function({ nbPages = 0, page = 0 }) {
    let back = '';
    let next = '';

    if (page > 0) {
        back = `<button type="submit" form="search-form" name="p" value="${page - 1}">Previous page</button>`;
    }
    if (nbPages > 0 && nbPages > (page + 1)) {
        next = `<button type="submit" form="search-form" name="p" value="${page + 1}">Next page</button>`;
    }
    return `<span id="search-pagination">${back}${next}</span>`;
};

const showSnippet = function(_snippetResult) {
    if (!_snippetResult || !_snippetResult.body || !_snippetResult.body.value) {
        return '';
    }
    return `<div class="snippet">...${_snippetResult.body.value}...</div>`;
};

// MIB cats are all crazy so map names to slugs here.
const catMap = {
    comics: 'comics-writing',
    announcements: 'announcements',
    reviews: 'comics-writing/reviews',
    'my comics': 'my-comics',
    essays: 'essays',
    journal: 'journal',
    anthologies: 'my-comics/anthologies-my-comics',
    'books and downloads': 'my-comics/books-and-downloads',
    exhibits: 'my-comics/exhibits-my-comics',
    'madinkbeard issues': 'my-comics/madinkbeard-issues',
    'short comics': 'my-comics/short-comics',
    series: 'my-comics/series-my-comics',
    rpgs: 'rpg',
    'the arts': 'arts',
    'the everyday': 'the-everyday'
};
/**
 * Link for keywords, tags, categories.
 * @param {String} keyword Keyword,tag,category
 * @param {Boolean} mib Is it from mib blog
 * @param {Boolean} isCat Is it from categories array
 * @returns {String}
 */
const getKeywordUrl = function(keyword, mib = false, isCat = false) {
    if (mib) {
        if (isCat) {
            const slug = catMap[keyword] || keyword;
            return `https://madinkbeard.com/archives/category/${slug}`;
        }
        return `https://madinkbeard.com/archives/tag/${slugify(keyword, slugConf)}`;
    }
    return `https://journal.derikbadman.com/tags/${slugify(keyword, slugConf)}`;
};

const showKeywords = function({ keywords, mib = false, categories = [] }) {
    if (keywords.length === 0) {
        return '';
    }
    return `<div class="keywords">
        ${categories.map((k) => { return `<a href="${getKeywordUrl(k, mib, true)}">${k}</a>` }).join(' ')}
        ${keywords.map((k) => { return `<a href="${getKeywordUrl(k, mib)}">${k}</a>` }).join(' ')}
    </div>`;
};
/**
 * Url.
 * @param {String} slug Post/entry slug.
 * @param {Boolean} mib Is it from mib archive
 * @returns
 */
const getUrl = function({ slug, mib = false }) {
    if (!slug) {
        return '';
    }
    if (mib) {
        return `https://madinkbeard.com/archives/${slug}`;
    }
    return `https://journal.derikbadman.com/entries/${slug}`;
};

const showResults = function({ hits = [], page = 0, hitsPerPage = 20 }) {
    const results = document.getElementById('search-results');
    let html = `<ol start="${page * hitsPerPage + 1}">`;
    hits.forEach((hit) => {
        html += `<li>
            <a href="${getUrl(hit)}">${hit.title}</a>${hit.date ? ` (${hit.date})` : ''}
            ${showSnippet(hit._snippetResult)}
            ${showKeywords(hit)}
        </li>`;
    });
    html += '</ol>';
    results.innerHTML = html;
};

/**
 * Show an error for a query.
 */
const showError = function() {
    const meta = document.getElementById('search-meta');
    meta.innerHTML = 'An error occurred while searching.';
};

const applyKeyword = function(keyword) {

};

/**
 * Send a query.
 * @param {String} query Search query string
 * @param {Number} page Page to return (0 indexed).
 */
const searchIndex = function(query, page = 0) {
    if (!query) {
        return;
    }
    index.search(
        query,
        {
            page,
            attributesToRetrieve: ['*', '-body'],
            attributesToSnippet: ['body:30']
        }
    )
        .then((results) => {
            showMetadata(results);
            showResults(results);
            searchInput.value = query;
        })
        .catch((err) => {
            console.error(err);
            showError();
        })
};

// Search form
const searchForm = document.getElementById('search-form');
const searchInput = searchForm.querySelector('input[name="query"]');

/**
 * Send search based on query string.
 */
const processQueryString = function() {
    const params = new URLSearchParams(window.location.search);
    const query = params.get('query');
    if (query) {
        const page = Number(params.get('p') || 0);
        searchInput.value = query;
        searchIndex(query, page);
    }
};

// Check on load for query string.
processQueryString();
